module.exports = __webpack_public_path__ + "media/payments/discount-tag-48afbbc3.svg";